export interface FinanceAccount {
  agent_id: number;
  agent_name: string;
  currency: "CNY";
  available_minor: number;
  frozen_minor: number;
  total_minor: number;
  version: number;
  updated_at: string;
}
export type FinanceLedgerKind = "recharge" | "deduct" | "freeze" | "release" | "settlement";
export interface FinanceLedger {
  id: number;
  agent_id: number;
  agent_name: string;
  portal_task_id?: number;
  kind: FinanceLedgerKind;
  amount_minor: number;
  available_delta_minor: number;
  frozen_delta_minor: number;
  available_after_minor: number;
  frozen_after_minor: number;
  reason: string;
  reference?: string;
  receipt_url?: string;
  created_at: string;
}
export const ledgerKindLabels: Record<FinanceLedgerKind, string> = {
  recharge: "后台充值", deduct: "平账扣款", freeze: "任务冻结", release: "余额解冻", settlement: "任务结算",
};
/** Convert entered yuan without rounding a third decimal place into a charge. */
export function amountToMinor(value: number | string | null | undefined): number | null {
  if (value == null) return null;
  const match = String(value).trim().match(/^(\d+)(?:\.(\d{1,2}))?$/);
  if (!match) return null;
  const minor = Number(match[1]) * 100 + Number((match[2] || "").padEnd(2, "0"));
  return Number.isSafeInteger(minor) ? minor : null;
}
export function taskBudgetMinor(unitMinor: number, quantity: number): number | null {
  if (!Number.isSafeInteger(unitMinor) || unitMinor <= 0 || !Number.isSafeInteger(quantity) || quantity <= 0) return null;
  const budget = unitMinor * quantity;
  return Number.isSafeInteger(budget) ? budget : null;
}
export function balanceShortfall(budgetMinor: number | null, availableMinor: number | undefined): number | null {
  if (budgetMinor === null || availableMinor === undefined || !Number.isSafeInteger(availableMinor) || availableMinor < 0) return null;
  return Math.max(0, budgetMinor - availableMinor);
}
export type TaskFinanceStatus = "not_frozen" | "frozen" | "released" | "settled";
export interface TaskFinance {
  portal_task_id: number;
  agent_id: number;
  agent_name: string;
  title: string;
  version: number;
  task_status: string;
  status: TaskFinanceStatus;
  unit_amount_minor: number;
  quota: number;
  budget_minor: number;
  frozen_minor: number;
  valid_count: number;
  charge_minor: number;
  release_minor: number;
  can_settle: boolean;
  block_reason: string;
  settlement_mode?: "manual" | "auto";
  settled_at?: string | null;
}
export const financeStatusLabels: Record<TaskFinanceStatus, string> = {
  not_frozen: "未冻结", frozen: "已冻结", released: "已解冻", settled: "已结算",
};
